<template>
  <ion-app id="app">
    <router-view v-if="!this.$store.state.user"></router-view>
    <!-- <router-view></router-view> -->

    <ion-app v-if="this.$store.state.user">
      <ion-tabs>
        <router-view></router-view>

        <ion-tab-bar slot="bottom" v-if="this.$route.name !== 'kind'">
          <ion-tab-button :to="{ name: 'home' }" :selected="this.isActive('home')">
            <ion-label>Home</ion-label>
            <ion-icon name="home"></ion-icon>
          </ion-tab-button>
          <ion-tab-button tab="edit" :to="{ name: 'edit' }" :selected="this.isActive('edit')">
            <ion-label>Bewerk</ion-label>
            <ion-icon name="create"></ion-icon>
          </ion-tab-button>
          <!-- <ion-tab-button
            tab="profile"
            :to="{ name: 'profile' }"
            :selected="this.isActive('profile')"
          >
            <ion-label>Profiel</ion-label>
            <ion-icon name="people"></ion-icon>
          </ion-tab-button>-->
          <ion-tab-button
            tab="settings"
            :to="{ name: 'settings' }"
            :selected="this.isActive('settings')"
          >
            <ion-label>Instellingen</ion-label>
            <ion-icon name="settings"></ion-icon>
          </ion-tab-button>

          <ion-tab-button
            :to="{ name: 'kind' }"
            :selected="this.isActive('kind')"
          >
            <ion-label>Kind</ion-label>
            <ion-icon name="home"></ion-icon>
          </ion-tab-button>
        </ion-tab-bar>
      </ion-tabs>
    </ion-app>
  </ion-app>
</template>
<style lang="scss">
$fontsDir: "/fonts/";
$einaDir: $fontsDir + "eina/";
@font-face {
  font-family: "Eina";
  src: url($einaDir+"eina-01-bold.woff2") format("woff2"),
    url($einaDir+"eina-01-bold.woff") format("woff"), url($einaDir+"eina-01-bold.ttf") format("ttf"),
    url($einaDir+"eina-01-bold.eot?#iefix") format("eot");
  font-weight: 700;
  unicode-range: U+000-5FF;
}

@font-face {
  font-family: "Eina";
  src: url($einaDir+"eina-01-semibold.woff2") format("woff2"),
    url($einaDir+"eina-01-semibold.woff") format("woff"),
    url($einaDir+"eina-01-semibold.ttf") format("ttf"),
    url($einaDir+"eina-01-semibold.eot?#iefix") format("eot");
  font-weight: 500;
  unicode-range: U+000-5FF;
}

@font-face {
  font-family: "Eina";
  src: url($einaDir+"eina-01-regular.woff2") format("woff2"),
    url($einaDir+"eina-01-regular.woff") format("woff"),
    url($einaDir+"eina-01-regular.ttf") format("ttf"),
    url($einaDir+"eina-01-regular.eot?#iefix") format("eot");
  font-weight: 400;
  unicode-range: U+000-5FF;
}

:root {
  --ion-font-family: "Eina", Helvetica Neue, Helvetica, sans-serif;
}

.font-md {
  font-weight: 500;
}
</style>
<script>
import * as firebase from "firebase/app";

export default {
  data() {
    return {};
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    isActive(tabID) {
      if (tabID === this.$route.name) {
        return true;
      }
    },
    storeUser() {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.$store.dispatch("storeUser", user);
        }
      });
    }
  },
  created() {
    this.storeUser();
  }
};
</script>
